import React from "react";
import {
  ChevronRight, Sparkles,
  PenLine, FileText, Compass, Share2, Palette, Monitor, Video, Film,
  BarChart3, Mail, MousePointerClick, Megaphone, Globe, Server,
  Briefcase, PhoneCall, Search, Radar, MessageSquare, UserCheck,
  Database, BookUser, Layers, Settings, ClipboardCheck, Users,
  Headphones, Award, Route, LifeBuoy, Code,
} from "lucide-react";

const PROFESSION_ICONS = {
  "copywriter": PenLine,
  "redator": FileText,
  "estrategista-conteudo": Compass,
  "social-media": Share2,
  "designer": Palette,
  "web-designer": Monitor,
  "videomaker": Video,
  "editor-videos": Film,
  "analista-marketing": BarChart3,
  "analista-email-marketing": Mail,
  "gestor-trafego": MousePointerClick,
  "gestor-marketing": Megaphone,
  "estrategista-digital": Globe,
  "analista-infra-mkt": Server,
  "gestor-comercial": Briefcase,
  "closer": PhoneCall,
  "sdr": Search,
  "bdr": Radar,
  "vendedor-whatsapp": MessageSquare,
  "social-seller": UserCheck,
  "sales-ops": Database,
  "analista-crm": BookUser,
  "gestor-produto": Layers,
  "gestor-operacoes-digitais": Settings,
  "gerente-projetos-digitais": ClipboardCheck,
  "gestor-comunidade": Users,
  "gestor-atendimento-digital": Headphones,
  "analista-cs": Award,
  "analista-cx": Route,
  "suporte-alunos": LifeBuoy,
  "vibe-coder": Code,
};

export { PROFESSION_ICONS };

const BARRIER_CONFIG = {
  baixa: { label: "Fácil entrada", bg: "#EAFAF6", text: "#00664C" },
  alta:  { label: "Requer experiência", bg: "#FADBDF", text: "#892E38" },
};

export default function ProfessionCard({ profession, onClick, recommended }) {
  const barrier = BARRIER_CONFIG[profession.barrier];
  const Icon = PROFESSION_ICONS[profession.id];

  return (
    <button
      onClick={() => onClick(profession)}
      className="w-full text-left bg-white rounded-2xl p-4 hover:shadow-md transition-all duration-200 group"
      style={{ border: '1px solid #E5E9EA' }}
      onMouseEnter={e => e.currentTarget.style.borderColor = '#00DCA4'}
      onMouseLeave={e => e.currentTarget.style.borderColor = '#E5E9EA'}
    >
      <div className="flex items-start gap-3">
        <div
          className="flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center"
          style={{ background: "#EAFAF6", boxShadow: "0 0 10px rgba(0, 220, 164, 0.25)" }}
        >
          {Icon ? <Icon className="w-5 h-5" style={{ color: "#00664C" }} /> : null}
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-sm" style={{ color: "#1A1D1E" }}>{profession.name}</p>
          <p className="text-xs mt-0.5 line-clamp-2" style={{ color: "#646C6F" }}>{profession.tagline}</p>
          <div className="flex flex-wrap items-center gap-1.5 mt-2">
            {barrier && (
              <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                style={{ background: barrier.bg, color: barrier.text }}>
                {barrier.label}
              </span>
            )}
            {recommended && (
              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium"
                style={{ background: "#B0FCEA", color: "#003326" }}>
                <Sparkles className="w-3 h-3" />
                Recomendada pra você
              </span>
            )}
          </div>
        </div>
        <ChevronRight className="w-4 h-4 flex-shrink-0 mt-1 transition-colors" style={{ color: '#D9DBDA' }} />
      </div>
    </button>
  );
}
